import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getNotificationsAPI } from "../api/notificationAPI";

export const useNotifications = (customerId: string | null) => {
  const query = useQuery({
    queryKey: ["notifications", customerId],
    queryFn: () => getNotificationsAPI(customerId!),
    enabled: !!customerId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    gcTime: 600000, // 10 minutes - keeps data in cache for 10 min
  });

  return query;
};

export const useRefreshNotifications = (customerId: string | null) => {
  const queryClient = useQueryClient();

  return () => {
    if (customerId) {
      queryClient.invalidateQueries({
        queryKey: ["notifications", customerId],
      });
    }
  };
};
